// extracted by mini-css-extract-plugin
module.exports = {"profileCardGrid":"SearchResultList_profileCardGrid__iY2fP"};